// By convention, actions that end in "_SUCCESS" are assumed to have been the result of a completed
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";

export const LOAD_LOCALIZATIONS_SUCCESS = "LOAD_LOCALIZATIONS_SUCCESS";

export const LOAD_CURRENT_MENTORS_BY_ID_SUCCESS = "LOAD_CURRENT_MENTORS_BY_ID_SUCCESS";

export const LOAD_ACCESS_INFO_SUCCESS = "LOAD_ACCESS_INFO_SUCCESS";

export const SET_CAMERA_PERMISSION_DONE = "SET_CAMERA_PERMISSION_DONE";
export const SET_LOCATION_PERMISSION_DONE = "SET_LOCATION_PERMISSION_DONE";
export const ENTERED_INTO_QUEUE_SUCCESS = "ENTERED_INTO_QUEUE_SUCCESS";
export const POSITION_UPDATED = "POSITION_UPDATED";
export const CHECK_QUEUE_PLACEMENT_SUCCESS = "CHECK_QUEUE_PLACEMENT_SUCCESS";

export const SESSION_HAS_OBSERVER_COMPLETE = "SESSION_HAS_OBSERVER_COMPLETE";
export const SESSION_HAS_ACTIVE_MENTEE = "SESSION_HAS_ACTIVE_MENTEE";
export const HEARTBEAT_COMPLETE = "HEARTBEAT_COMPLETE";
export const POLICY_HOLDER_PHOTO_SUCCESS = "POLICY_HOLDER_PHOTO_SUCCESS";
export const OPT_OUT_OF_PORTRAIT_PHOTO_SUCCESS = "OPT_OUT_OF_PORTRAIT_PHOTO_SUCCESS";
export const POLICY_HOLDER_PHOTO_CLEARED = "POLICY_HOLDER_PHOTO_CLEARED";
export const END_CLIENT_SESSION_SUCCESS = "END_CLIENT_SESSION_SUCCESS";
export const END_CLIENT_SESSION_FOR_LATER_SUCCESS = "END_CLIENT_SESSION_FOR_LATER_SUCCESS";
export const GET_LIVESWITCH_TOKEN_SUCCESS = "GET_LIVESWITCH_TOKEN_SUCCESS";
export const SET_FULLSCREEN_CONTAINER = "SET_FULLSCREEN_CONTAINER";
export const FULLSCREEN_UPDATED = "FULLSCREEN_UPDATED";
export const GET_SCHEDULESLOTS_SUCCESS_SILENT = "GET_SCHEDULESLOTS_SUCCESS_SILENT";

export const REQUEST_PHOTO = "REQUEST_PHOTO";
export const ERROR_LOADING_GUIDESTREAM = "ERROR_LOADING_GUIDESTREAM";

export const PRIVACY_STATEMENT_ACCEPTED = "PRIVACY_STATEMENT_ACCEPTED";
export const SCHEDULE_SET_OPTIMISTIC = "SCHEDULE_SET_OPTIMISTIC";
export const SCHEDULE_SET_FAILED = "SCHEDULE_SET_FAILED";

export const ENQUEUE_SNACKBAR = "ENQUEUE_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";

export const SAVE_FEEDBACK_OPTIMISTIC_COMPLETE = "SAVE_FEEDBACK_OPTIMISTIC_COMPLETE";

export const SAVE_AUDIORATING_OPTIMISTIC_COMPLETE = "SAVE_AUDIORATING_OPTIMISTIC_COMPLETE";
export const SAVE_VIDEORATING_OPTIMISTIC_COMPLETE = "SAVE_VIDEORATING_OPTIMISTIC_COMPLETE";
export const SAVE_OVERALLRATING_OPTIMISTIC_COMPLETE = "SAVE_OVERALLRATING_OPTIMISTIC_COMPLETE";
export const CAN_LEAVE_UPDATED = "CAN_LEAVE_UPDATED";

export const UPDATE_CULTURE_SUCCESS = "UPDATE_CULTURE_SUCCESS";
